var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockThinFilled = function SvgLockThinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.861 13.44a1.86 1.86 0 0 1-1.152 1.718v1.958a.708.708 0 0 1-1.417 0v-1.958A1.858 1.858 0 0 1 12 11.581a1.86 1.86 0 0 1 1.861 1.858ZM7.525 7.35A4.48 4.48 0 0 1 12 2.875a4.48 4.48 0 0 1 4.475 4.475v.429h-8.95v-.43Zm10.899.429h-.95v-.43A5.481 5.481 0 0 0 12 1.876 5.481 5.481 0 0 0 6.525 7.35v.429h-.947c-.862 0-1.563.701-1.563 1.563v10.721c0 .861.7 1.562 1.563 1.562h12.846c.86 0 1.561-.7 1.561-1.562V9.342c0-.862-.7-1.563-1.561-1.563Z",
    fill: "currentColor"
  })));
};
export default SvgLockThinFilled;